import { css } from 'styled-components';

export const CommonTerminalContentCodeStyle = css`
  .terminal-content {
    position: relative;
  }

  .terminal-top {
    border-top-left-radius: 0.6rem;
    border-top-right-radius: 0.6rem;
    background: #3e4552;
    color: white;
    height: 3.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .terminal-code {
    display: flex;
    margin-top: 0 !important;
  }

  .terminal-content code[class*='language-'],
  .terminal-content pre[class*='language-'] {
    color: #bac8d4;
    background: #282c33;
    flex-grow: 1;
    font-weight: 600;
  }

  .terminal-content .token.number,
  .terminal-content .token.function {
    color: #ffaf00;
  }

  .terminal-content .token.user {
    color: #bac8d4;
  }

  .terminal-top:after {
    display: block;
    position: absolute;
    content: '';
    top: 14px;
    left: 1rem;
    width: 0.5rem;
    height: 0.5rem;
    border-radius: 50%;
    background-color: #f44;
    box-shadow: 0 0 0 0.2rem #f44, 1.5rem 0 0 0.2rem #b2e028, 3rem 0 0 0.2rem #ff9c07;
  }

  .terminal-content.attacker .terminal-code,
  .terminal-content.attacker code[class*='language-'] {
    background: #512323;
  }

  .terminal-content.defender .terminal-code,
  .terminal-content.defender code[class*='language-'] {
    background: #1e3c61;
  }
`;
